import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { BankAccount } from '@tradecafe/types/core'
import { from } from 'rxjs'
import { map, switchMap, tap } from 'rxjs/operators'
import { BanksService } from 'src/pages/admin/settings/admin-setting-payments/banks/banks.service'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { catchAndLog } from 'src/shared/utils/catch-and-log'
import { createBank, createBankFailure, createBankSuccess, deleteBank, deleteBankFailure, deleteBankSuccess, loadBanks, loadBanksFailure, loadBanksSuccess, updateBank, updateBankFailure, updateBankSuccess } from './bank.actions'

@Injectable()
export class BankEffects {
  private actions$ = inject(Actions)
  private Banks = inject(BanksService)
  private toaster = inject(ToasterService)


  loadBanks$ = createEffect(() => this.actions$.pipe(
    ofType(loadBanks),
    switchMap(() =>
      from(this.Banks.getBanks()).pipe(
        map(banks => loadBanksSuccess({ banks })),
        catchAndLog(this.toaster, 'Unable to fetch banks', loadBanksFailure)))))

  createBank$ = createEffect(() => this.actions$.pipe(
    ofType(createBank),
    tap(() => this.toaster.progress('Creating bank...')),
    switchMap(action =>
      from(this.Banks.create(action.bank)).pipe(
        map(bank => createBankSuccess({ bank })),
        tap(() => this.toaster.success('Bank created successfully.')),
        catchAndLog(this.toaster, 'Unable to create bank', createBankFailure)))))

  updateBank$ = createEffect(() => this.actions$.pipe(
    ofType(updateBank),
    tap(() => this.toaster.progress('Updating bank...')),
    switchMap(action =>
      from(this.Banks.update({ bank_id: action.id, ...action.bank })).pipe(
        map(bank => updateBankSuccess({ bank })),
        tap(() => this.toaster.success('Bank updated successfully.')),
        catchAndLog(this.toaster, 'Unable to update bank', updateBankFailure)))))

  deleteBank$ = createEffect(() => this.actions$.pipe(
    ofType(deleteBank),
    tap(() => this.toaster.progress('Deleting bank...')),
    switchMap(action =>
      from(this.Banks.remove({ bank_id: action.id } as BankAccount)).pipe(
        map(r => deleteBankSuccess({ id: action.id })),
        tap(() => this.toaster.success('Bank deleted successfully.')),
        catchAndLog(this.toaster, 'Unable to delete bank', deleteBankFailure)))))
}
